import { t } from "i18next";
import { ClipModal } from "@components/ClipModal/ClipModal";
import { CharacterPickerPanel } from "./CharacterPickerPanel";
import type { SelectedCharacterPayload } from "./types";

export type { SelectedCharacterPayload } from "./types";

export interface SelectCharacterModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (payload: SelectedCharacterPayload) => void;
  /** 当前已选中的角色 id，用于回显选中态 */
  selectedId?: number | null;
}

/**
 * 视频复刻「选择模特/角色」弹窗 — 设计稿节点 5722:42384。
 *
 * 用 ClipModal 包裹，内嵌 CharacterPickerPanel；选中后立刻 onSelect 并关闭，
 * 与 SelectProductModal 的交互范式保持一致。
 */
export const SelectCharacterModal = ({ open, onClose, onSelect, selectedId = null }: SelectCharacterModalProps) => {
  const handleSelect = (payload: SelectedCharacterPayload) => {
    onSelect(payload);
    onClose();
  };

  return (
    <ClipModal
      open={open}
      onCancel={onClose}
      width={720}
      title={t("Select Character")}
      styles={{ body: { padding: 0 } }}
    >
      <CharacterPickerPanel selectedId={selectedId} onSelect={handleSelect} />
    </ClipModal>
  );
};
